/** Placeholder view for sections not yet implemented. */

export function Placeholder({ title }: { title: string }) {
  return (
    <div className="pad-fluid">
      <h1 className="text-3xl font-bold text-rogue-900">{title}</h1>
      <p className="text-rogue-600 mt-2">Coming next.</p>
    </div>
  );
}
